export default __webpack_public_path__ + "static/media/425property-gallery2.4e98a99e.webp";